import React from 'react';
import {useSelector} from 'react-redux';
import {
  pinsSearchFilterSet,
  pinsSearchRequest,
  pinsSearchResultsClear,
  pinsSearchSortSet
} from '../../reducers/pinsReducer';
import PinsList from './PinsList';
import PinsListController from './PinsListController';
import PinsListFilters from './PinsListFilters';
import PinsFeatured from './PinsFeatured';
import PinFolderModal from './PinFolderModal';

const PinsView = ({}) => {
  const isPlaceIdsSearch = useSelector(s => s.pins.pinsListSearch.ids); // could be a cluster or single 3d place
  const isSearching = !!useSelector(s => s.ui.txtInputPlacesLists.textInputField);
  const isUserPinsOnly = useSelector(s => s.pins.pinsListSearch.filter) === 'createdByUser';

  return (
    <>
      <PinsListFilters
        stateKey="pinsListSearch"
        textInputStateKey="txtInputPlacesLists"
        onFilterSet={pinsSearchFilterSet}
        onSortSet={pinsSearchSortSet}
      />

      <PinsListController
        onClearPins={pinsSearchResultsClear}
        onRequestPins={pinsSearchRequest}
        stateKey="pinsListSearch"
        textInputStateKey="txtInputPlacesLists"
      />

      {!isPlaceIdsSearch && <PinsFeatured/>}

      <PinsList
        columns={2}
        isFiltered={isSearching || isUserPinsOnly || isPlaceIdsSearch}
        onRequestPins={pinsSearchRequest}
        stateKey="pinsListSearch"
        textInputStateKey="txtInputPlacesLists"
      />

      <PinFolderModal/>
    </>
  );


};

export default PinsView;
